// Copyright (c) 2025 WiseTime. All rights reserved.

/**
 * Default rounding preference in seconds (6 minute units = 0.1 hours)
 */
export const DEFAULT_ROUNDING_PREFERENCE_SECONDS = 360
